import { render, staticRenderFns } from "./complexTodo-new.vue?vue&type=template&id=7e4d9070&scoped=true"
import script from "./complexTodo-new.vue?vue&type=script&lang=js"
export * from "./complexTodo-new.vue?vue&type=script&lang=js"
import style0 from "./complexTodo-new.vue?vue&type=style&index=0&id=7e4d9070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4d9070",
  null
  
)

export default component.exports